module.exports = __webpack_public_path__ + "static/media/tetrix_kraussi.fd7c99b6.jpg";